

import React from 'react';
import { compose } from 'recompose';
import { hot } from 'react-hot-loader';
import styled from 'styled-components';
import Truncate from 'react-truncate';

import { withTruncation } from './remarks.helper';

const ExpandtTruncated = styled.div`
  text-align: center;
  color: gray;
  :before {
    content: '« ';
  }
  :after {
    content: ' »';
  }  
`;

const Remarks = ({ value, lines, truncated, setTruncated }) => (
  <div>
  	<Truncate
      lines={ truncated ? lines : false }>
      {
        (value || '')
          .split('\r')
          .map((item, key) => <span key={key}>{item}<br/></span>)
      }
    </Truncate>
    <ExpandtTruncated onClick={(e) => { e.preventDefault(); setTruncated(!truncated); }}>{ truncated ? 'More' : 'Less' }</ExpandtTruncated>
  </div>
);

export default compose(
  hot(module),
	withTruncation
)(Remarks);